import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { purchasedSchema, usePurchasedForm } from './use-purchased-form';
import Form from '../../../../../components/form';
import { route } from '../../../../../services/utils';
import { WAREHOUSE_MOVEMENT_INDEX } from '../../../../../router/routes';
import useEditFooter from '../use-edit-footer';
import { useDealState } from '../use-deal-state';
import DealType from '../../../../../enums/deal-type';
import { useDealUpdate } from '../use-deal-update';
import TabsKeys from '../../../../../enums/tab-keys';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import DrawerForm from '../drawer-form';
import { useWarehouseContext } from '../warehouse-context';
import { dealSchema } from '../use-deal-form';
import useDealErrorModal from '../use-deal-error-modal';
import useFormTrigger from '../use-form-trigger';

const MODE = 'edit';
const additionalParametersKeys = ['PLANT_PROTECTION_PRODUCTS', 'MEDICATION'];

export default function EditPurchased() {
  const { farmId, dealType } = useParams<{
    farmId: string;
    dealType: DealType;
  }>();
  const {
    isOpen,
    isPartnerRequired,
    modalAddPartner,
    setFormMethods,
    PRODUCT_OBTAIN_REQUIRED,
    exceptionProducts,
  } = useWarehouseContext();

  const form = purchasedSchema(isPartnerRequired);

  const formMethods = useForm({
    resolver: yupResolver(form),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const drawerModalFormMethods = useForm({
    resolver: yupResolver(
      dealSchema(
        PRODUCT_OBTAIN_REQUIRED.includes(dealType),
        additionalParametersKeys.includes(exceptionProducts),
      additionalParametersKeys[1] === exceptionProducts,
      )
    ),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    if (modalAddPartner) {
      setFormMethods(formMethods);
    }
  }, [modalAddPartner, setFormMethods, formMethods]);

  const dealState = useDealState(DealType.purchased);
  const body = usePurchasedForm(formMethods, MODE);
  const footer = useEditFooter();
  const submit = useDealUpdate();
  const errorModal = useDealErrorModal(formMethods);

  useFormTrigger(formMethods);

  return (
    <>
      <Form
        title={'pages.warehouse.deals.edit-deal'}
        backTo={route(WAREHOUSE_MOVEMENT_INDEX, {
          farmId,
          tab: TabsKeys.deals,
        })}
        mode={MODE}
        body={body}
        footer={footer}
        values={dealState}
        schema={form}
        submit={submit}
        formMethods={formMethods}
      />
      {modalAddPartner}
      {isOpen && (
        <DrawerForm
          formMethods={formMethods}
          drawerModalFormMethods={drawerModalFormMethods}
        />
      )}
      {errorModal}
    </>
  );
}
